import { fetchSimDocumentsToken } from "../../authentication/AuthenticationHelper";
import axios from "axios";

interface PostDocumentParams {
    file: File | null,
    documentTypeGuid: string,
    startDate: string | null,
    endDate: string | null,
    linkType: string,
    url: string | null,
    fileName: string | null, 
    comment: string | null,
    languages: string[],
    productCompany: string | null,
    serialNumber: string | null,
    productNumbers: string[] | null,
    models: string[] | null,
}

export const postDocument = async ({
    file, 
    documentTypeGuid, 
    startDate, 
    endDate, 
    linkType, 
    url, 
    fileName, 
    comment, 
    languages, 
    productCompany, 
    serialNumber, 
    productNumbers, 
    models,
}: PostDocumentParams) => {
    const token = await fetchSimDocumentsToken();
    
    const formData = new FormData();
    if (file) formData.append('File', file);
    formData.append('DocumentTypeGuid', documentTypeGuid);
    if (startDate) formData.append('StartDate', startDate);
    if (endDate) formData.append('EndDate', endDate);
    formData.append('LinkType', linkType);
    if (url) formData.append('Url', url);
    if (fileName) formData.append('FileName', fileName);
    if (comment) formData.append('Comments', comment);
    languages.forEach(language => formData.append('Languages', language));
    if (productCompany) formData.append('ProductCompany', productCompany);
    if (serialNumber) formData.append('SerialNumber', serialNumber);
    else if (productNumbers) productNumbers.forEach(productNumber => formData.append('ProductNumbers', productNumber));
    else if (models) models.forEach(model => formData.append('Models', model));

    const config = {
        headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
    };

    await axios.post(
        process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL + "/v1/SIMDocuments/Documents",
        formData,
        config
    );
}
